import "./CurrentUser/currentuser.scss";
import { type FC } from "react";
import { UserInfo } from "./CurrentUser/UserInfo";

export const CurrentUser: FC = () => {
    return (
        <div
            id="current-user"
            className="header-item"
            data-testid="sh-current-user"
        >
            <UserInfo />
        </div>
    );
};
